import classnames from 'classnames';
import React from 'react';
import SortIcon from 'components/helpers/SvgIcon/icons/sortIcon';
import SvgIcon from 'components/helpers/SvgIcon/SvgIcon';
import ReactTooltip from 'react-tooltip';
import type { SortFunctionType } from '../types';

interface HeadingProps {
  label?: string;
  sortTable: SortFunctionType;
  sortIndicator: {
    columName: string;
    isAscending: boolean;
  };
  showSortIcon?: boolean;
  sortName?: string;
  showToolTip?: boolean;
  toolTipContent?: string;
}
const TcSearchHeading = ({
  label,
  sortIndicator,
  sortTable,
  showSortIcon,
  sortName,
  showToolTip,
  toolTipContent,
}: HeadingProps) => {
  return (
    <div className={classnames('flex', 'flex-row', 'w-full', 'content-center')}>
      {label}
      {showToolTip && (
        <>
          <div data-tip data-for="global" className={classnames('hidden', 'sm:block')}>
            <SvgIcon
              icon="info"
              size="xxs"
              viewBoxSize="0 0 24 24"
              className={classnames('ml-1', 'mt-1')}
            />
          </div>
          <ReactTooltip id="global" className="max-w-[350px]" type="dark" effect="solid">
            <p>{toolTipContent}</p>
          </ReactTooltip>
        </>
      )}
      {showSortIcon && (
        <div className={classnames('hidden', 'md:block', 'ml-auto')}>
          <span className={classnames('flex', 'flex-col', 'content-center', 'ml-2')}>
            <button
              className={classnames('pl-2.5', 'underline')}
              type="button"
              onClick={() => sortTable(sortName as string, false)}
              aria-label={`Sort by ${label} descending`}
            >
              <SortIcon
                color={
                  sortIndicator.columName === sortName && !sortIndicator.isAscending
                    ? 'black'
                    : '#AAAAAD'
                }
                inverted={false}
              />
            </button>
            <button
              className={classnames('pl-2.5', 'underline')}
              type="button"
              onClick={() => sortTable(sortName as string, true)}
              aria-label={`Sort by ${label} ascending`}
            >
              <SortIcon
                color={
                  sortIndicator.columName === sortName && sortIndicator.isAscending
                    ? 'black'
                    : '#AAAAAD'
                }
                inverted
              />
            </button>
          </span>
        </div>
      )}
    </div>
  );
};

export default TcSearchHeading;
